import React from 'react';
import { Check } from 'lucide-react';

interface Props {
  onSubmit: () => void;
}

export const Confirmation = ({ onSubmit }: Props) => {
  return (
    <div className="text-center">
      <div className="mb-6">
        <div className="w-16 h-16 bg-[#4B6BFB] rounded-full flex items-center justify-center mx-auto">
          <Check size={32} className="text-white" />
        </div>
      </div>

      <h2 className="text-2xl font-semibold text-gray-900 mb-2">
        All set! Welcome to Safora.
      </h2>
      <p className="text-gray-600 mb-8">
        Your company is ready. Let's get started managing your team.
      </p>

      <button
        onClick={onSubmit}
        className="w-full md:w-auto px-8 py-3 bg-[#4B6BFB] text-white rounded-full hover:bg-[#4B6BFB]/90"
      >
        Go to Dashboard
      </button>
    </div>
  );
};